import {newSet} from '../../actions/library/sets'
 


const SET_TITLE_MAX_CHARACTER_LENGTH=60


export function convertToSet(currentQuestion) {

	return(dispatch) => {
		const nowDate = new Date()
		const  questionBody=currentQuestion.body
		const newSetData = {
			'folder': currentQuestion.folder,
			'name': questionBody.substring(0, SET_TITLE_MAX_CHARACTER_LENGTH),
			'description': '',
			'questions': [currentQuestion],
			'clientModified': nowDate,
			'archived': false,
			'userCreated': nowDate,
			'repo':null,
			'lastEditedAt':nowDate
		}

		return dispatch(newSet(newSetData)).then((response) => {
			return response
		})
	}
}





